import {Directive, HostListener} from '@angular/core';
import {LongPressSingleton} from "../long-press/LongPressSingleton";

/**
 * Generated class for the HandleMultipleTouchDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[handle-multiple-touch]' // Attribute selector
})
export class HandleMultipleTouchDirective {

  constructor() {
    console.log('Hello HandleMultipleTouchDirective Directive');
  }

  @HostListener('touchstart', ['$event'])
  onTouch(event: Event) {
    const longPressTimer = LongPressSingleton.getInstance();
    const currentDate = Date.now();
    if (currentDate - longPressTimer.inputTouchDelay > 300) {
      // console.log("OK");
      longPressTimer.inputTouchDelay = currentDate;
    } else {
      // return false;
      // console.log("CANCEL");
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }

}



// WEBPACK FOOTER //
// ./src/directives/handle-multiple-touch/handle-multiple-touch.ts